import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export interface IAppState {
  siderbar: boolean;
  multiTab: boolean;
  // device: string;
  // theme: string;
  // layout: string;
  // fixedHeader: boolean;
  // multiTab: boolean;
}

@Module({ dynamic: true, store, name: 'app', namespaced: true })
class App extends VuexModule implements IAppState {
  siderbar = true;
  device = 'desktop';
  theme = '';
  layout = '';
  contentWidth = '';
  fixedHeader = false;
  fixSiderbar = false;
  autoHideHeader = false;
  color = null;
  weak = false;
  multiTab = false;
  collapsed = false;

  // scrollTop 滚动 距离顶部高度是否超过120px(头部标题高度)
  isScrollTop = false;

  @Mutation
  TOGGLE_SIDEBAR() {
    this.siderbar = !this.siderbar;
  }

  @Mutation
  TOGGLE_COLLAPSED() {
    this.collapsed = !this.collapsed;
    // console.log(this.collapsed);
  }

  @Mutation
  setCOLLAPSED(param: boolean) {
    // console.log('set:', param);
    this.collapsed = param;
  }

  @Mutation
  setScrollTop(param: boolean) {
    this.isScrollTop = param;
  }

  @Action({ commit: 'TOGGLE_SIDEBAR' })
  toggleSidebar() {}

  @Action({ commit: 'TOGGLE_COLLAPSED' })
  toggleCollapsed() {}
}

const AppModule = getModule(App);
export default AppModule;
